// eslint-disable-next-line @alltrails/custom/use-client
'use client'; // Needed for denali Icons

import Button from '@alltrails/denali/components/Button';
import { IconComponent } from '@alltrails/denali/components/Icon';
import { IconDefinition } from '@alltrails/denali/components/IconRenderer';
import Bell from '@alltrails/denali/icons/Bell';
import Bookmark from '@alltrails/denali/icons/Bookmark';
import Calendar from '@alltrails/denali/icons/Calendar';
import CheckCircleFilled from '@alltrails/denali/icons/CheckCircleFilled';
import CheckSm from '@alltrails/denali/icons/CheckSm';
import Comment from '@alltrails/denali/icons/Comment';
import Facebook from '@alltrails/denali/icons/Facebook';
import Hiking from '@alltrails/denali/icons/Hiking';
import Instagram from '@alltrails/denali/icons/Instagram';
import Link from '@alltrails/denali/icons/Link';
import Message from '@alltrails/denali/icons/Message';
import Play from '@alltrails/denali/icons/Play';
import Search from '@alltrails/denali/icons/Search';
import Star from '@alltrails/denali/icons/Star';
import styles from './CmsButton.module.scss';

const iconMap: Record<string, IconComponent> = {
  Bell,
  Bookmark,
  Calendar,
  CheckCircleFilled,
  CheckSm,
  Comment,
  Facebook,
  Hiking,
  Instagram,
  Link,
  Message,
  Play,
  Search,
  Star
};

const createIconDefinition = (iconName: string): IconDefinition<'orientation'> | undefined => {
  const iconComponent = iconMap[iconName];
  return iconComponent ? { Component: iconComponent } : undefined;
};

type CmsButtonProps = {
  testId?: string;
  buttonText: string;
  href: string;
  iconName?: string;
};

export default function CmsButton({ testId, buttonText, iconName, href }: CmsButtonProps) {
  const icon = iconName ? createIconDefinition(iconName) : undefined;
  const linkInfo = href ? { href } : undefined;

  return (
    <div className={styles.cmsButton}>
      <Button testId={testId} text={buttonText} icon={icon} linkInfo={linkInfo} variant="default" />
    </div>
  );
}
